import styled from 'styled-components';

const ListItem = styled.li`
  &:not(:first-child) {
    margin: 20px 0 0;
  }
`;

export default ListItem;
